// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2t2Vv","content":"styles_content__1yCIY","selectAll":"styles_selectAll__5CW_F"};